import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getSkyboxSessions, setSkyboxCredentials, revealSkyboxCredentials, setSkyboxSessionTokens, clearSkyboxSession,
} from '../api';

// Per-pricer Skybox sessions for the Admin → Users tab (super admin only).
export const skyboxSessionKeys = { all: ['skybox-sessions'] };

export function useSkyboxSessions(options = {}) {
  return useQuery({
    queryKey: skyboxSessionKeys.all,
    queryFn: async () => (await getSkyboxSessions()).data,
    refetchInterval: 30000,
    ...options,
  });
}

function invalidating(mutationFn) {
  return function useIt() {
    const qc = useQueryClient();
    return useMutation({ mutationFn, onSuccess: () => qc.invalidateQueries({ queryKey: skyboxSessionKeys.all }) });
  };
}

export const useSetSkyboxCredentials = invalidating(({ id, email, password }) => setSkyboxCredentials(id, { email, password }));
export const useSetSkyboxSessionTokens = invalidating(({ id, token, refreshToken }) => setSkyboxSessionTokens(id, { token, refreshToken }));
export const useClearSkyboxSession = invalidating(({ id }) => clearSkyboxSession(id));
export const revealCredentials = revealSkyboxCredentials;
